<script>
import jQuery from "jquery";
export default {
  data() {
    return {
      // Array of classes and properties to be applied
      reRenderCssSelectors: [],
      // reRenderCssSelectors: [
      //   {
      //     jquerySelectors: null,
      //     properties: [
      //       {
      //         propertyName: null,
      //         propertyValue: null,
      //       },
      //     ],
      //   },
      // ],
    };
  },
  methods: {
    getWindowHeightInPx() {
      return jQuery(window).height() + "px";
    },
    forceRerender() {
      this.reRenderCssSelectors.forEach((selectors) => {
        selectors.properties.forEach((prop) => {
          jQuery(selectors.jquerySelectors).css(
            prop.propertyName,
            prop.isCallBack ? prop.propertyValue() : prop.propertyValue
          );
        });
      });

      this.$forceUpdate();
    },
  },
  mounted() {
    jQuery(window).resize(() => {
      this.forceRerender();
    });
  },
};
</script>
